import { useQuery } from '../index';
import { gql } from '@apollo/client';
import permissions from '../Apollo/permissions';

const query = gql`
  query ClientSideIntegrations {
    fetch_integrations {
      status
      data
    }
  }
`;

export default ({ variables, ...options } = {}) => {
  const { data, loading, isAllowed, error } = useQuery(query, {
    variables,
    context: { permission: permissions.readPipeline },
    ...options, // see https://www.apollographql.com/docs/react/api/react/hooks/ for options
  });

  return {
    data: data?.fetch_integrations.data || [],
    loading,
    isAllowed,
    error,
  };
};
